import { createAction, createAsyncAction, createAsyncTypes } from 'lib/reduxUtils';

// Sync
export const RESET_STORE = 'email/resetStore';
export const resetStore = createAction(RESET_STORE);

// Async
export const SEND_EMAIL = createAsyncTypes('email/sendEmail');
export const sendEmail = createAsyncAction(SEND_EMAIL);
